import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card card-bordered"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { style: {"display":"flex","width":"100%"} }
const _hoisted_4 = {
  class: "card-title",
  style: {"flex":"1","width":"100%"}
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_6 = { class: "symbol symbol-50px me-5" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "card card-custom gutter-b" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "Overview")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" })
], -1)
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "form-group mb-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Status", -1)
const _hoisted_21 = { class: "form-control form-control-solid" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = { class: "form-group mb-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Offer Name", -1)
const _hoisted_26 = { class: "form-control form-control-solid" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = { class: "form-group mb-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Offer ID", -1)
const _hoisted_31 = { class: "form-control form-control-solid" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = { class: "form-group mb-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Offer Type", -1)
const _hoisted_36 = { class: "form-control form-control-solid" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-sm-6" }
const _hoisted_39 = { class: "form-group mb-6" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Countries", -1)
const _hoisted_41 = { class: "form-control form-control-solid" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-sm-6" }
const _hoisted_44 = { class: "form-group mb-6" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "OS", -1)
const _hoisted_46 = { class: "form-control form-control-solid" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-sm-6" }
const _hoisted_49 = { class: "form-group mb-6" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Payout", -1)
const _hoisted_51 = { class: "form-control form-control-solid" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-sm-6" }
const _hoisted_54 = { class: "form-group mb-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Impression Cap", -1)
const _hoisted_56 = { class: "form-control form-control-solid" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-sm-6" }
const _hoisted_59 = { class: "form-group mb-6" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Click Cap", -1)
const _hoisted_61 = { class: "form-control form-control-solid" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-sm-6" }
const _hoisted_64 = { class: "form-group mb-6" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Conversion Cap", -1)
const _hoisted_66 = { class: "form-control form-control-solid" }
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "card card-custom gutter-b" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "Additional data")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" })
], -1)
const _hoisted_70 = { class: "card-body" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-sm-6" }
const _hoisted_73 = { class: "form-group mb-6" }
const _hoisted_74 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_75 = { class: "symbol symbol-50px me-5" }
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_78 = ["href"]
const _hoisted_79 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-sm-6" }
const _hoisted_82 = { class: "form-group mb-6" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Traffic Type", -1)
const _hoisted_84 = { class: "form-control form-control-solid" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-sm-6" }
const _hoisted_87 = { class: "form-group mb-6" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Preview URL", -1)
const _hoisted_89 = { class: "form-control form-control-solid" }
const _hoisted_90 = { class: "row" }
const _hoisted_91 = { class: "col-sm-6" }
const _hoisted_92 = { class: "form-group mb-6" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Click Link", -1)
const _hoisted_94 = { class: "form-control form-control-solid" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-sm-6" }
const _hoisted_97 = { class: "form-group mb-6" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Impression Link", -1)
const _hoisted_99 = { class: "form-control form-control-solid" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = { class: "col-sm-6" }
const _hoisted_102 = { class: "form-group mb-6" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6 form-label" }, "Description", -1)
const _hoisted_104 = {
  class: "form-control form-control-solid readonly",
  readonly: "readonly",
  rows: "4"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_loader = _resolveComponent("dw-loader")!
  const _component_event_payouts = _resolveComponent("event-payouts")!
  const _component_targeting_tab = _resolveComponent("targeting-tab")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_dw_loader, { active: _ctx.busy }, null, 8, ["active"]),
    (_ctx.offer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, "[" + _toDisplayString(_ctx.offer.id) + "] " + _toDisplayString(_ctx.offer.name), 1),
              (_ctx.offer.asset_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: _ctx.offer.asset_icon
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("a", {
                        class: "text-dark fw-bolder text-hover-primary mb-1 fs-6",
                        href: _ctx.offer.preview_url,
                        target: "_blank"
                      }, _toDisplayString(_ctx.offer.asset_name), 9, _hoisted_9),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.offer.asset_app_id) + " / " + _toDisplayString(_ctx.offer.asset_package_id), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.offer.status), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.offer.name), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.offer.id), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.offer.payout_model), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.offer.country), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.offer.platform), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_event_payouts, {
                              events: _ctx.offer.events
                            }, null, 8, ["events"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.offer.daily_impression_cap), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.offer.daily_click_cap), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.offer.daily_conversion_cap), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          (_ctx.offer.asset)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("img", {
                                    src: _ctx.offer.asset.icon
                                  }, null, 8, _hoisted_76)
                                ]),
                                _createElementVNode("div", _hoisted_77, [
                                  _createElementVNode("a", {
                                    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6",
                                    href: _ctx.offer.asset.preview_url,
                                    target: "_blank"
                                  }, _toDisplayString(_ctx.offer.asset.name), 9, _hoisted_78),
                                  _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.offer.asset.app_id) + " / " + _toDisplayString(_ctx.offer.asset.package_id), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _hoisted_83,
                          _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.offer.type), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _hoisted_88,
                          _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.offer.preview_url), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("div", _hoisted_92, [
                          _hoisted_93,
                          _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.offer.pub_click_url ? `${_ctx.offer.pub_click_url}&aff_clickid={clickid}&sub1={sub1}` : ''), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _hoisted_98,
                          _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.offer.pub_impression_url ? `${_ctx.offer.pub_impression_url}&aff_clickid={clickid}&sub1={sub1}` : ''), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _hoisted_103,
                          _createElementVNode("textarea", _hoisted_104, _toDisplayString(_ctx.offer.description), 1)
                        ])
                      ])
                    ]),
                    _hoisted_105
                  ])
                ])
              ])
            ]),
            _createVNode(_component_targeting_tab, {
              offer: _ctx.offer,
              "onUpdate:offer": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.offer) = $event))
            }, null, 8, ["offer"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}